import { Component, Input, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { modalEnterAnimation, modalLeaveAnimation } from 'src/app/animation/modal.animation';
import { CreditCard } from 'src/app/models/credit-card.model';
import { DataService } from 'src/app/services/data.service';
import { GetTranslationService } from 'src/app/services/get-translation.service';
import { NewCardComponent } from '../new-card/new-card.component';

@Component({
  selector: 'app-credit-cards',
  templateUrl: './credit-cards.component.html',
  styleUrls: ['./credit-cards.component.scss'],
})
export class CreditCardsComponent implements OnInit {

  @Input() url: string;

  creditCards: CreditCard[] = JSON.parse(localStorage.getItem('cards')) || [];


  constructor(
    public dataServ: DataService,
    private mdlctrl: ModalController,
    private translator: GetTranslationService,
    private alertCtrl: AlertController
  ) { }

  ngOnInit() { }

  async close() {
    await this.mdlctrl.dismiss();
  }

  async addNew() {
    const MODAL = await this.mdlctrl.create({
      component: NewCardComponent,
      enterAnimation: modalEnterAnimation,
      leaveAnimation: modalLeaveAnimation
    });

    await MODAL.present();
    await MODAL.onDidDismiss();

    this.creditCards = JSON.parse(localStorage.getItem('cards')) || [];
  }

  async deleteCard(index: number) {

    const MSG = await this.translator.getTranslate('Are you sure? You are deleting your credit card info, this action cannot be undone!');
    const YES = await this.translator.getTranslate('Yes');
    const NO = await this.translator.getTranslate('No');

    const ALERT = await this.alertCtrl.create({
      message: MSG,
      buttons: [
        {
          text: NO,
          role: NO
        },
        {
          text: YES,
          role: YES,
          handler: async () => {
            this.creditCards.splice(index, 1);
            localStorage.setItem('cards', JSON.stringify(this.creditCards));
          }
        }
      ]
    });

    ALERT.present();
  }
}
